import { useMemo as p, useCallback as i } from "react";
const E = "(?:p|div|h[1-6]|li)", o = "data-systemeio-trailing-break", a = /\bdata-pm-slice=/, b = new RegExp(
  `<br\\b(?=[^>]*\\b${o}(?:=(?:"true"|'true'|true))?)[^>]*\\/?>`,
  "gi"
), _ = new RegExp(
  `<br\\b(?=[^>]*\\bclass=(?:"[^"]*\\btrailingBreak\\b[^"]*"|'[^']*\\btrailingBreak\\b[^']*'))[^>]*\\/?>`,
  "gi"
), u = new RegExp(
  `<(${E})(\\b[^>]*)>(\\s*)<\\/\\1>`,
  "gi"
), l = new RegExp(
  `(<br\\b(?![^>]*\\b${o}\\b)[^>]*\\/?>)(?=\\s*<\\/${E}>)`,
  "gi"
), c = () => `<br ${o}="true">`, R = (r) => r.replace(u, (t, s, n, e) => `<${s}${n}>${e}${c()}</${s}>`).replace(l, `$1${c()}`), A = (r) => r.replace(b, "").replace(_, ""), g = (r) => a.test(r) ? R(r) : r, I = (r, t) => {
  const s = p(() => {
    const e = r ?? "";
    return t === "html" && typeof e == "string" ? A(e) : e;
  }, [r, t]), n = i(
    (e) => t === "html" ? R(e) : e,
    [t]
  );
  return { preprocessedContent: s, postprocessContent: n };
};
export {
  R as postprocessHtmlForExport,
  A as preprocessHtmlForEditor,
  g as preprocessPastedHtmlForEditor,
  I as useProcessContent
};
